"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useValidateTimeslotAvailability = exports.useValidateTimeslot = exports.isBookingLateChange = exports.handleAppointmentError = exports.getRecurringRuleFromProps = exports.ManageAppointmentTarget = exports.AppointmentType = void 0;
var _react = _interopRequireWildcard(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = require("lodash");
var _ = require("./..");
var _utils = require("../../utils");
var _components = require("../../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ManageAppointmentTarget = /*#__PURE__*/function (ManageAppointmentTarget) {
  ManageAppointmentTarget["One"] = "one";
  ManageAppointmentTarget["All"] = "all";
  return ManageAppointmentTarget;
}({});
exports.ManageAppointmentTarget = ManageAppointmentTarget;
var AppointmentType = /*#__PURE__*/function (AppointmentType) {
  AppointmentType["OneOff"] = "one-off";
  AppointmentType["Recurring"] = "recurring";
  return AppointmentType;
}({});
exports.AppointmentType = AppointmentType;
var isBookingLateChange = function isBookingLateChange(startsAt) {
  return (0, _momentTimezone.default)(startsAt).diff((0, _momentTimezone.default)(), 'hours') < 24;
};
exports.isBookingLateChange = isBookingLateChange;
var getRecurringRuleFromProps = function getRecurringRuleFromProps(_ref) {
  var appointment = _ref.appointment,
    patient = _ref.patient;
  return (appointment === null || appointment === void 0 ? void 0 : appointment.recurringRule) || (patient === null || patient === void 0 ? void 0 : patient.recurringRule) || (0, _lodash.first)(patient === null || patient === void 0 ? void 0 : patient.recurringRules) || {};
};
exports.getRecurringRuleFromProps = getRecurringRuleFromProps;
var handleAppointmentError = function handleAppointmentError(error) {
  var _ref2 = error.response || {},
    data = _ref2.data;
  if ((data === null || data === void 0 ? void 0 : data.code) === 'ERR400_84') {
    _utils.toast.error({
      title: 'There was a problem reaching the clinician’s calendar',
      description: 'Please check that they have connected a calendar and try again.'
    });
  } else if ((data === null || data === void 0 ? void 0 : data.code) === 'ERR400_78') {
    _utils.toast.error({
      title: 'Something went wrong',
      description: 'Unfortunately this time slot is no longer available. Please choose another one.'
    });
  } else {
    _utils.toast.error({
      title: 'Something went wrong'
    });
  }
};
exports.handleAppointmentError = handleAppointmentError;
var useValidateTimeslotAvailability = function useValidateTimeslotAvailability() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$checkMonument = params.checkMonumentBookingsOnly,
    checkMonumentBookingsOnly = _params$checkMonument === void 0 ? false : _params$checkMonument;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    warning = _useState2[0],
    setWarning = _useState2[1];
  var _useRequest = (0, _utils.useRequest)(function (_ref3) {
      var clinicianId = _ref3.clinicianId,
        appointmentSlot = _ref3.appointmentSlot;
      return {
        method: 'get',
        url: (0, _utils.getClinicianAvailabilityValidationUrl)(clinicianId, _objectSpread(_objectSpread({}, (0, _lodash.pick)(appointmentSlot, ['start', 'end'])), {}, {
          checkMonumentBookingsOnly: checkMonumentBookingsOnly
        })),
        withErrorsHandler: false
      };
    }, {
      manual: true,
      onError: function onError(error) {
        var _error$response, _error$response$data;
        if ((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.code) === 'ERR400_78') {
          setWarning(checkMonumentBookingsOnly ? 'The selected time slot is occupied by a Monument appointment and cannot be booked.' : 'Please note that the selected time slot is outside of the clinician’s availability.');
          return;
        }
        throw error;
      },
      onSuccess: function onSuccess() {
        if (warning) {
          setWarning(undefined);
        }
      }
    }),
    loading = _useRequest.loading,
    run = _useRequest.run;
  return {
    loading: loading,
    run: run,
    warning: warning
  };
};
exports.useValidateTimeslotAvailability = useValidateTimeslotAvailability;
var useValidateTimeslot = function useValidateTimeslot() {
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    warning = _useState4[0],
    setWarning = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isBookingDisabled = _useState6[0],
    setIsBookingDisabled = _useState6[1];
  var checkMonumentBookings = (0, _utils.isAdmin)(user);
  var _useValidateTimeslotA = useValidateTimeslotAvailability(),
    loadingCronofyAvailabilityValidation = _useValidateTimeslotA.loading,
    runCronofyAvailabilityValidation = _useValidateTimeslotA.run,
    cronofyAvailabilityValidationWarning = _useValidateTimeslotA.warning;
  var _useValidateTimeslotA2 = useValidateTimeslotAvailability({
      checkMonumentBookingsOnly: checkMonumentBookings
    }),
    loadingMonumentAvailabilityValidation = _useValidateTimeslotA2.loading,
    runMonumentAvailabilityValidation = _useValidateTimeslotA2.run,
    monumentAvailabilityValidationWarning = _useValidateTimeslotA2.warning;
  var loading = loadingCronofyAvailabilityValidation || loadingMonumentAvailabilityValidation;
  (0, _react.useEffect)(function () {
    if (loadingCronofyAvailabilityValidation || loadingMonumentAvailabilityValidation) {
      return;
    }
    setIsBookingDisabled(!!monumentAvailabilityValidationWarning);
    setWarning(monumentAvailabilityValidationWarning || cronofyAvailabilityValidationWarning);
  }, [loadingCronofyAvailabilityValidation, loadingMonumentAvailabilityValidation, monumentAvailabilityValidationWarning, cronofyAvailabilityValidationWarning]);
  return {
    run: function run(params) {
      runCronofyAvailabilityValidation(params);
      if (checkMonumentBookings) {
        runMonumentAvailabilityValidation(params);
      }
    },
    loading: loading,
    warning: warning ? /*#__PURE__*/_react.default.createElement(_components.Alert, {
      type: _components.AlertTypeEnum.Alert,
      className: "tw-body-sm-light"
    }, warning) : null,
    setWarning: setWarning,
    isBookingDisabled: isBookingDisabled
  };
};
exports.useValidateTimeslot = useValidateTimeslot;